<template>
    <div class="container pa-3">
      <v-row>
        <!--Notification Bar-->
        <v-col cols="12">
            <v-alert v-if="message.show" dismissible color="green darken-3" type="info">{{message.text}}</v-alert>
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Upcoming Activation</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <dashboard-activation-data-table
            :AM="AM"
            :CC="CC"
          />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Campaign Brief</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <campaign-brief-data-table
            :AM="AM"
            :CC="CC"
            @viewCampaign="getCampaignDataToView"
          />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Pairing</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <pairing-lineup-data-table
            :AM="AM"
            :CC="CC"
            @viewCampaign="getCampaignDataToView"
          />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Drafts</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <drafts-data-table
            :AM="AM"
            :CC="CC"
            @viewCampaign="getCampaignDataToView"
          />
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <!-- <div style="padding:0 20px">
            <div class="sub-title">Reporting</div>
            <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
          </div> -->
          <reporting-data-table
            :AM="AM"
            :CC="CC"
            @viewCampaign="getCampaignDataToView"
          />
        </v-col>
      </v-row>
      <change-password-modal
      v-model="passwordModalDialog"
      :value="passwordModalDialog"
      @changePassword="passwordChanged"
    ></change-password-modal>
    <view-campaign-modal :modalId="'view_campaign_modal'" v-model="viewCampaignModalDialog" :value="viewCampaignModalDialog" :campaignData="viewCampaignData" />
    </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex';
import ChangePasswordModal from '../User/ChangePasswordModal';
import totalNumber from '../DashboardComponents/TotalNumbers';
import BarChart from '../DashboardComponents/Chart/Bar.vue';
import SpendBarChart from './Chart/Bar.vue';
// import LineChart from './Chart/Line.vue';
import LineChart from '../DashboardComponents/Chart/Line.vue';
import QualityLineChart from '../DashboardComponents/Chart/Line.vue';
// import PostsSummary from '../DashboardComponents/PostsSummary.vue';
import CampaignSummary from '../DashboardComponents/CampaignSummary.vue';
import QualityRatingHelper from '../DashboardComponents/QualityRatingHelper'
import SpeedHelper from '../DashboardComponents/SpeedHelper'
import KobeOverViewHelper from '../DashboardComponents/KobeOverviewHelper'
import CampaignBriefDataTable from '../DashboardComponents/CampaignBriefDataTable.vue';
import DashboardActivationDataTable from '../DashboardComponents/DashboardActivationDataTable.vue';
import PairingLineupDataTable from '../DashboardComponents/PairingLineupDataTable.vue';
import DraftsDataTable from '../DashboardComponents/DraftsDataTable.vue';
import ReportingDataTable from '../DashboardComponents/ReportingDataTable.vue';
import ViewCampaignModal from '../Campaign/ViewCampaignModal'
import userAPIs from '../User/userAPIs';
import campaignAPIs from '../Campaign/campaignAPIs';
import config from '@/config';
import moment from 'moment';

import CData from './Chart/chart-data.json'
import mockUpData from './am_data.json'

export default {
  name: 'AM_Dashboard',
  components: {
    totalNumber,
    ChangePasswordModal,
    CampaignSummary,
    BarChart,
    SpendBarChart,
    LineChart,
    QualityLineChart,
    CampaignSummary,
    DashboardActivationDataTable,
    CampaignBriefDataTable,
    PairingLineupDataTable,
    DraftsDataTable,
    ReportingDataTable,
    ViewCampaignModal
  },
  data() {
    return {
      passwordModalDialog: false,
      pwdWarning: false,
      message: {
        show: false,
        text: '',
        type: 'info'
      },
      chartCompletionData: [],
      completionSummary: [],
      chartRevenueData: [],
      revenueSummary: [],
      chartRenewalData: [],
      renewalSummary: [],
      averageAmountChartData: [],
      averageAmountSummary: [],
      totalSummaryData: {},
      campaigns: [],
      AMUsers: [],
      FilterAMUsers: [],
      benchmark: 4, 
      benchmarkColor: {r: 255, g: 99, b: 132},
      yAxes: {
        min: 0,
        max: 5,
        stepSize: 1,
        label: 'Score'
      },
      speedBenchmark: 20, 
      speedYAxes: {
        min: 0,
        max: 30,
        stepSize: 5,
        label: 'Days'
      },
      spendRevBenchmark: 100000, 
      spendAvgBenchmark: 20000,
      SPEED_TURNAROUND: {
        id: 'campaign_speed_turnaround_chart',
        title: 'Turnaround for Campaign - Filter by',
        labels: [],
        datasets: []
      },
      SPEND_REVENUE: {
        id: 'spend_revenue_chart',
        title: 'Filter by',
        labels: [],
        datasets: [],
        summaryTitle: 'Revenue Summary',
        summary: []
      },
      SPEND_AVG_PER_CAMPAIGN: {
        id: 'spend_avg_per_campaign_chart',
        title: 'Filter by',
        labels: [],
        datasets: [],
        summaryTitle: 'Average Amount Per Campaign',
        summary: []
      },
      CLIENT_SATISFACTION: {
        id: 'client_line_chart',
        title: 'CLIENT Satisfaction - Filter by',
        labels: [],
        datasets: []
      },
      influencerPerMonth: 'Total Influencer on ' + moment(Date.now()).format('MMMM'),
      campaignActivity: {
        ACTIVATION: 'activation',
        PAIRING: 'pairing',
        CREATING: 'creating',
        COMPLETE: 'complete'
      },
      AM: [],
      CC: [],
      viewCampaignData: null,
      viewCampaignModalDialog: false
    }
  },
  computed: {
    ...mapState(['user']),
    currentUserRole: function() {
      return this.user.role;
    },
    currentUserID: function() {
      return this.user.id;
    }
  },
  async mounted() {
    this.getUsers()
    this.pwdWarning = this.user.pwdWarning;
    this.chartCompletionData = CData.Speed.COMPLETION.MONTHLY
    this.chartRevenueData = CData.Speed.REVENUE.MONTHLY
    this.chartRenewalData = CData.Spend.RENEWAL.MONTHLY
    this.averageAmountChartData = CData.Spend.AVERAGE_AMOUNT.MONTHLY
    this.calculateCompletionSummary()
    this.calculateRevenueSummary()

    let response
    //get all campaigns
    response = await QualityRatingHelper.getAllCampaignsNoStatus()
    if (response) {
      this.campaigns = response
    }
    // Get all AM by role
    response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
    if(response) {
      this.AMUsers = response.users
      this.AMUsers = this.AMUsers.map(am => {
        am.name = `${am.firstName} ${am.lastName}`
        am.lineColor = this.randomLineColors()
        return am
      })
      this.filterUsers = this.AMUsers.slice()
      this.filterUsers.unshift({id: '', name: 'All Team'})
    }
    // this.totalSummaryData = await KobeOverViewHelper.getAMCODashboardTotal()
    this.getSpendRevenueData({monthly: true})
    this.getSpendAvgPerCampaign({monthly : true})
    this.getSpeedDataOverview({monthly : true})
    // this.getClientAvgRatingsOverview({monthly : true})
    this.calculateRenewalSummary()
    // this.calculateAverageAmountSummary(12)
  },
  methods: {
    async getSpendRevenueData(filters) {
      let queryFilter = this.getPeriodFilter(filters)
      let response = await campaignAPIs.getAllReportRecognized()
      if(response) {
        queryFilter.AMUserId = filters.firstFilterId ? filters.firstFilterId : ''
        let graphdata = this.getSpendRevenueGraphData(response, queryFilter)
        this.SPEND_REVENUE.labels = graphdata.periodLabels
        this.SPEND_REVENUE.datasets = graphdata.datasets
        this.SPEND_REVENUE.summary = graphdata.revenueSummary
      }
    },
    async getSpendAvgPerCampaign(filters) {
      let queryFilter = this.getPeriodFilter(filters)
      let response = await campaignAPIs.getAllReportRecognized()
      if(response) {
        queryFilter.AMUserId = filters.firstFilterId ? filters.firstFilterId : ''
        queryFilter.avg_per_campaign = true
        let graphdata = this.getSpendRevenueGraphData(response, queryFilter)
        this.SPEND_AVG_PER_CAMPAIGN.labels = graphdata.periodLabels
        this.SPEND_AVG_PER_CAMPAIGN.datasets = graphdata.datasets
        this.SPEND_AVG_PER_CAMPAIGN.summary = graphdata.revenueSummary
      }
    },
    getSpeedDataOverview(filters) {
      let queryFilter = {}
      if(filters.monthly) { queryFilter.monthly = true }
      if(filters.quarterly) { queryFilter.quarterly = true }
      if(filters.yearly) { queryFilter.yearly = true }
      SpeedHelper
      .getSpeedData('all', queryFilter)
      .then(response => {
        queryFilter.AMUserId = filters.firstFilterId ? filters.firstFilterId : ''
        let graphdata = this.getSpeedGraphData(response, queryFilter)
        this.SPEED_TURNAROUND.labels = graphdata.periodLabels
        this.SPEED_TURNAROUND.datasets = graphdata.datasets
      })
      .catch(error => {
        // Request failed.
        this.isLoading = false;
        console.log('error', error);
      });
    },
    getClientAvgRatingsOverview(filters) {
      let queryFilter = {}
      if(filters.monthly) { queryFilter.monthly = true }
      if(filters.quarterly) { queryFilter.quarterly = true }
      if(filters.yearly) { queryFilter.yearly = true }
      QualityRatingHelper
      .getClientAvgRatings(queryFilter, true)
      .then(response => {
        let clientAvgRatings = response.ratings
        let avgRates = this.calculateClientAvgOverall(clientAvgRatings)
        queryFilter.AMUserId = filters.firstFilterId ? filters.firstFilterId : ''
        let graphdata = this.getSatisfactionGraphData(avgRates, queryFilter)
        this.CLIENT_SATISFACTION.labels = graphdata.periodLabels
        this.CLIENT_SATISFACTION.datasets = graphdata.datasets
      })
      .catch(error => {
        // Request failed.
        this.isLoading = false;
        console.log('error', error);
      });
    },
    getSpendRevenueGraphData(data, filters) {
      //--------- (spend revenue summary bar chart, average per campaign line chart) graph data ---------//
      //find periods based on filter (monthly, quarterly, yearly)
      let allPeriods = []
      // for monthly, quarterly, get only this year data
      if(filters.monthly || filters.quarterly) {
        data = data.filter(d => d.year === parseInt(moment().format('YYYY')))
      }
      if(filters.monthly) {
        data = data.map(a => {
          a.period = a.month
          return a
        })
      } else if(filters.quarterly) { // for quarterly, get quarter by month-year
        // filter quarter
        data = data.map(d => {
          d.period = moment(d.year + '-' + d.month).quarter()
          return d
        })
      } else if(filters.yearly) {
        data = data.map(d => {
          d.period = d.year
          return d
        })
      }
      allPeriods = data.map(a => a.period && a.period)
      let periods = [...new Set(allPeriods.sort((a, b) => a - b))]
      if(filters.quarterly) { // add Q symbol for quarterly
        let quarterLabel = this.quarterLabels(periods, data)
        periods = quarterLabel.periods
        data = quarterLabel.data
      }
      let datasets = []
      let team = 0
      let revenueSummary = []
      let filterAM = []
      if(filters.AMUserId !== '') {
        filterAM = this.AMUsers.filter(c => c.id === filters.AMUserId)
      } else {
        filterAM = this.AMUsers
      }
      filterAM.map((am, key) => {
        let eachPeriodData = []
        periods.map(p => {
          let AMCampaigns = new Set()
          let eachTotalRate = 0
          data.map(d => {
            if (d.period === p) {
              let hasAMInCampaign = this.campaigns.some(c => (c.id === d.campaignId && (c.assignedTo && c.assignedTo.includes(am.id))))
              if (hasAMInCampaign) {
                AMCampaigns.add(d.campaignId)
                // calculate revenue
                if (d.revenueCalculation !== undefined) {
                  if (d.revenueCalculation === 'engagement') {
                    eachTotalRate += d.revenue
                  } else {
                    eachTotalRate += d.revenueByContents
                  }
                } else {
                  eachTotalRate += d.revenue
                }
              }
            }
          })
          eachTotalRate = Math.round(eachTotalRate, 0)
          // for average per campaigns, calculate by each AM campaigns count
          if(filters.avg_per_campaign) {
            eachTotalRate = eachTotalRate> 0 ? Math.round(eachTotalRate / AMCampaigns.size, 0) : 0
          }
          eachPeriodData.push(eachTotalRate)
        })
        let dataAttrs = {
          'label': am.name,
          'data': eachPeriodData,
          'stack': 'Stack ' + (key + 1)
        }
        if(filters.avg_per_campaign) { // for average per campaign line chart
          dataAttrs.borderColor = am.lineColor
          dataAttrs.fill = false
        } else { // for spend revenue bar chart
          dataAttrs.backgroundColor = am.lineColor
        }
        datasets.push(dataAttrs)
        let AMTotal = eachPeriodData.reduce((a, b) => a + b, 0)
        team += AMTotal
        revenueSummary.push(this.getSummaryObj(am.name, AMTotal))
      })
      let periodLabels = this.ratingPeriodLabels(filters,periods)
      let bechmarkAttr = {
        'label': `Benchmark`,
        'backgroundColor': `rgba(${this.benchmarkColor.r}, ${this.benchmarkColor.g}, ${this.benchmarkColor.b})`,
        'stack': 'Stack ' + 0
      }
      if(filters.avg_per_campaign) { // for average per campaign line chart
        bechmarkAttr.borderColor = `rgba(${this.benchmarkColor.r}, ${this.benchmarkColor.g}, ${this.benchmarkColor.b})`
        bechmarkAttr.fill = false
        bechmarkAttr.data = periods.map(p => this.spendAvgBenchmark) //change benchmark value
      } else { // for spend revenue bar chart
        bechmarkAttr.data = periods.map(p => this.spendRevBenchmark)
      }
      datasets.unshift(bechmarkAttr)
      let shortFall = this.spendRevBenchmark - team
      //sort AM summary from high to low
      revenueSummary = revenueSummary.sort((a,b) => b.data - a.data);
      // add team, benchmark, shortfall
      if (filters.AMUserId === '') {
        revenueSummary.push(this.getSummaryObj('Team', team))
      }
      revenueSummary.push(this.getSummaryObj('Benchmark', this.spendRevBenchmark),
      this.getSummaryObj('Shortfall', shortFall))
      // add SGD symbol
      revenueSummary = revenueSummary.map(r => { r.data = r.data + ' SGD';return r;})
      return {periodLabels, datasets, revenueSummary}
    },
    getSpeedGraphData(data, filters) {
      //find possible periods on all activities
      let allPeriods = []
      Object.keys(this.campaignActivity).map(function(key) {
        allPeriods = data[key].map(a => a.period && a.period)
      })
      let periods = [...new Set(allPeriods.sort())]
      let datasets = []
      let filterAM = []
      //------ get total average speed data based on periods for each CO from all campaign activity days ------//
      if(filters.AMUserId !== '') {
        filterAM = this.AMUsers.filter(c => c.id === filters.AMUserId)
      } else {
        filterAM = this.AMUsers
      }
      filterAM.map((am, key) => {
        let eachPeriodData = []
        periods.map(p => {
          let totalDays = 0
          let eachCOAvgDays = 0
          Object.keys(this.campaignActivity).map(function(key) {
            let AMCampaigns = data[key].filter(a => a.assignedTo && a.assignedTo.includes(am.id) && a.period === p)
            let days = AMCampaigns.map(c => c.days).reduce((one, two) => one + two, 0)
            totalDays += days
          })
          eachCOAvgDays = totalDays > 0 ?  Math.round(totalDays / Object.keys(this.campaignActivity).length, 0) : 0
          eachPeriodData.push(eachCOAvgDays)
        })
        datasets.push({
          'label': am.name,
          'data': eachPeriodData,
          'backgroundColor': am.lineColor,
          'stack': 'Stack ' + (key + 1)
        })
      })
      let benchmarkData = periods.map(p => this.speedBenchmark) //change benchmark value
      datasets.unshift({
        'label': `Benchmark`,
        'data': benchmarkData,
        'backgroundColor': `rgba(${this.benchmarkColor.r}, ${this.benchmarkColor.g}, ${this.benchmarkColor.b})`,
        'stack': 'Stack ' + 0
      })
      let periodLabels = this.ratingPeriodLabels(filters,periods)
      return {periodLabels, datasets}
    },
    getSatisfactionGraphData(avgRates, filters) {
      let periods = [...new Set(avgRates.map(a => a._id.period).sort())]
      let datasets = []
      let filterAM = []
      //------ get total average ratings data based on periods for each AM from all average ratings data ------//
      if(filters.AMUserId !== '') {
        filterAM = this.AMUsers.filter(c => c.id === filters.AMUserId)
      } else {
        filterAM = this.AMUsers
      }
      this.AMUsers.map((am, key) => {
        let eachPeriodData = []
        periods.map(p => {
          let AMCampaigns = 0
          let eachTotalRate = 0
          avgRates.map(av => {
            if (av._id.period === p) {
              let hasAMInCampaign = this.campaigns.some(c => (c.id === av._id.campaignID && (c.assignedTo && c.assignedTo.includes(am.id))))
              if (hasAMInCampaign) {
                AMCampaigns += 1
                eachTotalRate += av.avg_overall
              }
            }
          })
          eachTotalRate = (eachTotalRate > 0 && AMCampaigns > 0) ? Math.round(eachTotalRate / AMCampaigns) : 0
          eachPeriodData.push(eachTotalRate)
        })
        datasets.push({
          'label': `${am.firstName} ${am.lastName}`,
          'data': eachPeriodData,
          'borderColor': am.lineColor,
          'fill': false,
          'stack': 'Stack ' + (key + 1)
        })
      })
      
      let benchmarkData = periods.map(p => this.benchmark) //change benchmark value
      datasets.unshift({
        'label': `Benchmark`,
        'data': benchmarkData,
        'borderColor': `rgba(${this.benchmarkColor.r}, ${this.benchmarkColor.g}, ${this.benchmarkColor.b})`,
        'fill': false,
        'stack': 'Stack ' + 0
      })
      let periodLabels = this.ratingPeriodLabels(filters, periods)
      return {periodLabels, datasets}
    },
    calculateClientAvgOverall(clientAvgRatings) {
      let avgValues = [
        'avg_influencers_selection',
        'avg_content_quality_rate',
        'avg_campaign_timeline_rate',
        'avg_overall_experience_rate',
        'avg_draft_post'
      ]
      clientAvgRatings = clientAvgRatings.map(v => {
        let totalAvgs = 0
        avgValues.map(akey => {
          v[akey] = v[akey] ? Math.round(v[akey]) : 0
          totalAvgs += v[akey]
        })
        v.avg_overall = Math.round(totalAvgs / avgValues.length)
        return v
      })
      return clientAvgRatings
    },
    ratingPeriodLabels(filters, periods) {
      if (filters.hasOwnProperty('monthly')) {
        return periods.map(p => moment(p, 'MM').format('MMM'))
      }
      return periods
    },
    quarterLabels(periods, data) {
      periods = periods.map(p => 'Q' + p)
      data = data.map(d => {
        if(d.period.length) {
          d.period = d.period.map(p => 'Q' + p)
        } else if(d.period) {
          d.period = 'Q' + d.period
        }
        return d
      })
      return {periods, data}
    },
    randomLineColors() {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      if(r === this.benchmarkColor.r && g == this.benchmarkColor.g && b == this.benchmarkColor.b) { 
        // if benchmark color, regenerate color
        this.randomLineColors()
      }

      return "rgb(" + r + "," + g + "," + b + ")";
    },
    calculateCompletionSummary() {
      const dataset = CData.Speed.COMPLETION.MONTHLY.datasets
      dataset.map((item) => {
        let avgValue = item.data.reduce((a, b) => a + b) / 12
        let summaryObj = {
          "text": item.label,
          "value": Math.round(avgValue)
        }
        this.completionSummary.push(summaryObj)
      })
    },
    calculateRevenueSummary() {
      const dataset = CData.Speed.REVENUE.MONTHLY.datasets
      dataset.map((item) => {
        let summaryObj = {
          "text": item.label,
          "value": item.data.reduce((a, b) => a + b)
        }
        this.revenueSummary.push(summaryObj)
      })
    },
    calculateRenewalSummary() {
      const dataset = CData.Spend.RENEWAL.MONTHLY.datasets
      let total = 0
      dataset.map((item) => {
        let summaryObj = {
          'text': item.label,
          'value': item.data.reduce((a, b) => a + b)
        }
        total += summaryObj.value
        this.renewalSummary.push(summaryObj)
      })

      let totalRenewal = {
        'text': 'Total',
        'value': total
      }
      this.renewalSummary.push(totalRenewal)
    },
    calculateAverageAmountSummary(totalCount) {
      const dataset = CData.Spend.AVERAGE_AMOUNT.MONTHLY.datasets
      dataset.map((item) => {
        let avgValue = item.data.reduce((a, b) => a + b) / totalCount
        let summaryObj = {
          "text": item.label,
          "value": Math.round(avgValue)
        }
        this.averageAmountSummary.push(summaryObj)
      })
    },
    getPeriodFilter(filters) {
      let queryFilter = {}
      if(filters.monthly) { queryFilter.monthly = true }
      if(filters.quarterly) { queryFilter.quarterly = true }
      if(filters.yearly) { queryFilter.yearly = true }
      return queryFilter
    },
    getSummaryObj(label, data) {
      return {label, data}
    },
    speedDetail() {
      this.$router.push({name: 'am-speed'})
    },
    spendDetail() {
      this.$router.push({name: 'AM-Quality'})
    },
    spendRevenueDetail() {
      this.$router.push({name: 'am-spend-revenue'})
    },
    qualityDetail() {
      this.$router.push({name: 'AM-Quality'})
    },
    async getUsers() {
      try {
        let response = null
        // get clients
        await this.$store.dispatch('client/getClients')
        // Get all AM by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        if (response) {
          this.AM = response.users
          this.AM = this.AM.map(am => {
            am.name = `${am.firstName} ${am.lastName}`
            return am
          })
        }
        this.AM.unshift({id: '', name: 'All Team'})
        // Get all CC by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
        if (response) {
          this.CC = response.users
          this.CC = this.CC.map(cc => {
            cc.name = `${cc.firstName} ${cc.lastName}`
            return cc
          })
          this.CC.unshift({id: '', name: 'All Team'})
        }
      } catch (error) {
        // Request failed.
        console.log('error', error);
        return false
      }
    },
    getCampaignDataToView(campaignID) {
      campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.viewCampaignData = response
          this.viewCampaignModalDialog = true
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    }
  }
}
</script>
<style scoped>
  .sub-title {
    font-size: 28px !important;
    font-weight: 300;
  }
</style>




// WEBPACK FOOTER //
// index.vue?3e2a0a72